import React from "react";
import Layout from "../../../Layouts/Layout";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../../../services/reactQuery/reactQueryService";
import LegalbirdLoaderPage from "../../Loading/LegalbirdLoaderPage";
import { Conversation } from "../../../../types/Entities/Messaging/Conversation";
import MessageCenter from "../../../../components/Messaging/MessageCenter/MessageCenter";
import Container from "../../../../components/Container/Container";
import { Helmet } from "react-helmet-async";

export default function MessageCenterPage() {
  const conversationFilter = {
    "exists[containedMessages]": true,
  };

  const { data: conversations, isLoading: isLoadingConversations } = useQuery<Array<Conversation>, Error>({
    queryKey: queryKeys.collection("/conversations", conversationFilter),
    queryFn: () => fetchCollection("/conversations", conversationFilter),
  });

  const { data: minimalCases, isLoading: isLoadingMinimalCases } = useQuery({
    queryKey: queryKeys.collection("/collection/cases"),

    queryFn: () =>
      fetchCollection("/collection/cases")
  });

  if (isLoadingConversations || isLoadingMinimalCases) {
    return <LegalbirdLoaderPage />;
  }

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>Servicewelt Nachrichtenübersicht | Legalbird</title>
      </Helmet>
      <Container>
        <MessageCenter minimalCases={minimalCases || []} conversations={conversations || []} />
      </Container>
    </Layout>
  );
}
